import { Component, Input, OnDestroy  } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from '../../services/api.service';
import { BatchAlertService } from '../../services/batch-alert.service';
import { RootScopeService } from '../../services/root-scope.service';
import { CurrentBatch } from '../administration/administration.component';
import { DeleteBatchAlertComponent } from '../common/delete-batch-alert/delete-batch-alert.component';
import { ViewParticipantsComponent } from '../common/view-participants/view-participants.component';
import * as Constants from '../../models/Constants';
@Component({
  selector: 'app-current-batch-alert',
  templateUrl: './current-batch-alert.component.html',
  styleUrls: ['./current-batch-alert.component.scss'],
})
export class CurrentBatchAlertComponent implements OnDestroy  {

  /**** CCR1-5861 *****/
  errMsg: boolean = false;
  totalRecords: number = 8;
  @Input() selectedRow: any;

  constructor(
    public batchAlertService: BatchAlertService,
    private apiService: ApiService,
    public dialog: MatDialog,
    public rootService: RootScopeService
  ) {

  }




  openFilter() {
    this.batchAlertService.openCurrentBatchFilterDialog = true;
   }

  /* istanbul ignore next */
  deleteAlertModal() {
    this.dialog.open(DeleteBatchAlertComponent, {
      panelClass: 'delete-batch-alert',
      backdropClass: 'custom-overlay',
      id: 'deleteBatch',
      disableClose: true
    });
  }

  /* istanbul ignore next */
  rowSelection(data) {
    if(data?.row){
      this.batchAlertService.currentBatchSelectedRow = data?.row;
    }
  }

  /* istanbul ignore next */
  viewParticipantModal() {
    this.rootService.openViewParticipant = true;
  }

  clearFilter(){
    this.batchAlertService.currentBatchAlertData = new MatTableDataSource(this.batchAlertService.currentBatchTableDataMap.get(this.batchAlertService.clientId));
    this.batchAlertService.filterCurrentBatchAlertFormData = null;
    this.batchAlertService.filteronCurrentBatchAlertApplied = false;
    this.batchAlertService.currentBatchSelectedRow = null;
    this.selectedRow = !this.selectedRow;

  }
  
  ngOnDestroy(){
    this.batchAlertService.currentBatchSelectedRow = null;
    this.batchAlertService.deleteBatchAlertMsgSuccess = false;
    this.batchAlertService.deleteBatchAlertMsgFail = false;
    this.batchAlertService.deletedBatchAlertDetail = null;
    this.batchAlertService.openCurrentBatchFilterDialog = false;
  }
}
